<template>
  <div class="header-wrapper">
    <div class="header-content">
      <el-row type="flex" justify="space-between" align="botom">
        <el-col :span="8">
          <div class="header-logo cursor" @click="home">
            <img src="../../../assets/images/logo.png" />
          </div>
        </el-col>
        <el-col :span="8"></el-col>
        <el-col :span="8" class="header-icon">
          <!-- <router-link to="/cart" v-if="employeeLevel !== 85">
            <i class="iconfont iconzu51 cursor" title="购物车" />
          </router-link> -->
          <!-- <span  v-if="employeeLevel !== 85" @click="handlePocm('/cart')">
            <i class="iconfont iconzu51 cursor" title="购物车" />
          </span> -->

          <router-link to="/user/notice/list">
            <i class="iconfont iconzu71 cursor" title="通知" />
          </router-link>
          <el-dropdown trigger="hover" class="cursor">
            <span class="el-dropdown-link">
              <i class="iconfont iconzu61 cursor" v-popover:popover1 />
              <i class="el-icon-caret-bottom el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown" class="dropdown-user">
              <el-dropdown-item @click.native="userIndex">个人中心</el-dropdown-item>
              <!-- <el-dropdown-item @click.native="logout">退出POCM+</el-dropdown-item> -->
              <el-dropdown-item @click.native="logout">退出系统</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { localStorageUtils } from "@/utils/localstorage"
export default {
  data () {
    return {
      employeeLevel: ''
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  created () {
    this.employeeLevel = this.userInfo.employeeLevel
  },
  methods: {
    home () {
      this.$router.push({ name: 'home' })
    },
    userIndex () {
      this.$router.push('/user/index')
    },
    logout () {
      this.$confirm('是否确认退出登录', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        confirmButtonClass: 'btn-red',
        type: 'warning'
      })
        .then(() => {
          this.$store.dispatch('LogOut')
        })
        .catch(() => { })
    },
    // pocm订购
    async handlePocm (router) {
      try {
        const inUse = ['prod', 'test', 'dev'].includes(process.env.VUE_APP_ENV)
        const dataParams = {
          cacheKey: 'icircleShow'
        }
        const { data } = await this.$store.dispatch('checkIcircleStatus', dataParams)
        if (data.resultCode === '0') {
          const { icircleShow } = data.resultData
          if (icircleShow != 1 || !inUse) {
            this.$router.push(router)
            return
          }
          const token = localStorageUtils.get('eb-token')
          const urlMap = {
            dev: 'https://icircle-dev.abipocm.com/login-auto',
            test: 'https://icircle-test.abipocm.com/login-auto',
            prod: 'https://icircle.abipocm.com/login-auto'
          }
          let url = urlMap[process.env.VUE_APP_ENV]
          if (!url) {
            return
          }
          window.location.href = `${url}?token=${token}&targetUri=${router}`
        }
      } catch (error) {
        this.$router.push(router)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.header-wrapper {
  width: 100%;
  height: 80px;
  background-color: #fff;
  .el-row {
    height: 80px;
  }
  .header-content {
    width: 1200px;
    margin: auto;
    height: 100%;
    line-height: 80px;
    .header-logo {
      width: 124px;
      height: 36px;
      padding-top: 15px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .header-icon {
      text-align: right;
      color: #688db7;
      .iconfont {
        margin-left: 18px;
        font-size: 21px;
        color: #688db7;
      }
    }
  }
}
</style>
